import { useIntl, useDispatch, getLocale, useSelector } from 'umi';
import { FILTER_NAMESPACE } from '@/pages/intelligence/models/filter';
import { useEffect, useMemo, useState } from 'react';

export default function useGenreSelector(props: { filterType?: string; entityType?: stirng }) {
  const { entityType } = props;
  const dispatch = useDispatch();
  const { commonGrenreFilter } = useSelector((state) => {
    // @ts-ignore
    const { commonGrenreFilter } = state[FILTER_NAMESPACE];
    return {
      commonGrenreFilter,
    };
  });

  const modelValueName = () => {
    return {
      modelName: commonGrenreFilter,
      dispatchType: `${FILTER_NAMESPACE}/getCommonGenreFilter`,
      payload: {},
    };
  };

  const modelMsg = modelValueName();
  const [genreOptions, setGenreOptions] = useState(null);
  const [filterLoading, setFilterLoding] = useState(true);

  useEffect(() => {
    // 不能用!val， 因为它可能是undefind
    if (modelMsg?.modelName?.loading === false) {
      getGenreFilterApiData();
    }
  }, [modelMsg?.modelName?.loading]);

  const getGenreFilterApiData = async () => {
    const { modelName, dispatchType, payload } = modelMsg;
    if (modelName.loading === false && modelName.data === null) {
      try {
        setFilterLoding(true);
        // 如果数据为空则重新请求接口
        const res = await dispatch({
          type: dispatchType,
          payload: { ...payload, entityType },
        });
        setGenreOptions(res);
        setFilterLoding(false);
      } catch (err) {
        setFilterLoding(false);
      }
    } else {
      setFilterLoding(false);
      setGenreOptions(modelName.data);
    }
  };

  return {
    filterLoading,
    genreOptions,
  };
}

/** 通过品类字符串 获取品类对应的翻译
 * genre： 品类值
 * categories 品类数据 { ieg : [], annir :[]}
 */
export const findGenre = (genre: string, categories: any) => {
  const findInArray = (array: any[]) => {
    if (!Array.isArray(array)) {
      return null;
    }
    for (const item of array) {
      if (item?.main_genre?.genre === genre) {
        return { ...item, type: 'main' };
      }

      for (const subItem of item?.sub_genre) {
        if (subItem?.genre === genre) {
          return { ...subItem, type: 'sub' };
        }
      }
    }

    return null;
  };
  let type = 'iegg';
  let result = findInArray(categories?.ieg);
  if (result === null) {
    type = 'annie';
    result = findInArray(categories?.annir);
  }

  return { type, result };
};
